import React from "react";
import { ScrollArea, Table, createStyles, Text, Box } from "@mantine/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import RecordNotFound from "../RecordNotFound";
import TableLoader from "../TableLoader";
import ClientTableRow from "./ClientTableRow";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: "16px",
    transition: "box-shadow 150ms ease",
    "& th": {
      backgroundColor: "#fff",
      color: "#000 !important",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
    },
  },

  scrolled: {
    boxShadow: theme.shadows.sm,
  },
  notFoundContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
    height: "100vh",
    gap: "8rem",
  },
  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  },
  table: {
    borderRadius: "16px",
    border: "1px solid #E5E5E5",
    fontFamily: "Inter",
  },
}));

const ClientTable = ({ setSelectedClientRows, selectedClientRows, data }) => {
  const { classes, cx } = useStyles();
  const { loadingFacilityClients, facilityClients } = useSelector(
    (state) => state.staff
  );

  const [scrolled, setScrolled] = useState(false);

  const rows = facilityClients?.map((row, index) => {
    return (
      <ClientTableRow
        row={row}
        index={index}
        selectedClientRows={selectedClientRows}
        setSelectedClientRows={setSelectedClientRows}
        data={data}
        // selectedClient={selectedClient}
      />
    );
  });

  return (
    <ScrollArea
      onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
      sx={{ fontFamily: "Inter", backgroundColor: "#fff" }}
    >
      <Table
        withBorder
        fontSize={"sm"}
        highlightOnHover
        enablestickyheader
        verticalSpacing={"md"}
        className={classes.table}
      >
        <thead className={cx(classes.header, { [classes.scrolled]: scrolled })}>
          <tr>
            <th style={{ minWidth: "200px" }}>Client Name</th>
            <th style={{ minWidth: "160px" }}>Facility Name</th>
            <th style={{ minWidth: "100px" }}>Zip Code</th>
            <th style={{ minWidth: "140px" }}>Address</th>
            <th style={{ minWidth: "140px" }}>Gender</th>
            <th style={{ minWidth: "100px" }}>Phone</th>
          </tr>
        </thead>
        <tbody>
          {loadingFacilityClients ? (
            <tr>
              <td colSpan={1000}>
                <TableLoader />
              </td>
            </tr>
          ) : rows?.length ? (
            rows
          ) : (
            <tr>
              <td colSpan={1000}>
                <Box className={classes.notFoundContainer}>
                  <RecordNotFound />
                  <Text className={classes.notFoundText}>
                    You don&apos;t have any record
                  </Text>
                </Box>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </ScrollArea>
  );
};

export default ClientTable;
